import React, { useState } from "react";
import { PiSquaresFourLight } from "react-icons/pi";
import { CgFeed, CgProfile } from "react-icons/cg";
import { useAuth } from "../../Providers/Auth";
import { useLocation, useNavigate } from "react-router-dom";

import { useGeneralSettings } from "../../Providers/General";
import { GiTwoCoins } from "react-icons/gi";
import { TbCrown, TbMoodSad } from "react-icons/tb";
// import { toast } from "react-toastify";
import { IoMdOpen } from "react-icons/io";
import { IoDiamondOutline, IoFlashOutline } from "react-icons/io5";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/shadcnComponents/ui/accordion";
import { MdAutoGraph, MdOutlineContentCopy } from "react-icons/md";
import { toast } from "react-toastify";
import mixpanel from "mixpanel-browser";
import { Wallet } from "lucide-react";
import { CreatorNotificationPanel } from "../influencer/Notification/notification-panel";
import { HowLeaderBoardWorks } from "@/Pages/Dashboard/Influencer/Dashboard/DashboardComponents/DashboardOrganism/Leaderboard";

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const authState = useAuth();
  const generalState = useGeneralSettings();
  const [openLeaderboardInfo, setOpenLeaderboardInfo] = useState(false);

  return (
    <div
      className="hidden md:flex h-full  md:flex-col w-[260px] min-w-[260px] border-r-[1px] border-[#262626] p-5 box-border gap-5 font-inter z-10 bg-[#171717;]"
      style={{
        boxShadow: "4px 0px 8px 0px rgba(33, 33, 33, 0.08)",
        overflowY: "auto",
        scrollbarWidth: "none",
      }}
    >
      {openLeaderboardInfo && (
        <HowLeaderBoardWorks
          onClick={() => {
            setOpenLeaderboardInfo(false);
          }}
        />
      )}
      <div className="flex gap-1">
        <img
          src={
            // "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/anchors_Christmas.svg"
            // "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/DiwaliLogoBlack.png"
            // "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/Collab+White+Logo.svg"
            "https://anchors-assets.s3.ap-south-1.amazonaws.com/anchors+logo+with+white+text.png"
          }
          alt=""
          className="w-40 mb-5 cursor-pointer"
          onClick={() => {
            navigate("/");
          }}
        />
        <CreatorNotificationPanel />
      </div>

      {/* user info header */}
      <div className="flex items-center gap-2">
        <img
          src={
            authState?.loggedUser?.profile ||
            "https://anchors-collab.s3.ap-south-1.amazonaws.com/assets/creatorProfileIcon2.png"
          }
          alt=""
          className="w-10 h-10 rounded-full"
        />

        <section className="flex flex-col gap-1">
          <span className="text-[14px] font-medium text-[#A6A6A6]">
            {authState?.loggedUser?.name}
          </span>
          {authState?.loggedUser?.featuredData?.value &&
          authState?.loggedUser?.activePlan ? (
            <span
              onClick={() => {
                setOpenLeaderboardInfo(true);
              }}
              className="bg-[#FFDA44] text-[#292929] w-full cursor-pointer flex px-[8px] py-[4px] border-[1px] border-[#FFDA44] rounded-md items-center justify-center gap-1 text-xs font-medium hover:bg-[#FFE066] transition-colors"
            >
              <TbCrown size={16} /> FEATURED
            </span>
          ) : (
            <span
              onClick={() => {
                setOpenLeaderboardInfo(true);
              }}
              className="bg-[#E6E6E6] text-[#292929] w-full cursor-pointer flex px-[8px] py-[4px] border-[1px] border-[#CCCCCC] rounded-md items-center justify-center gap-1 text-xs font-medium hover:bg-[#F2F2F2] transition-colors"
            >
              <TbMoodSad size={16} /> NOT FEATURED
            </span>
          )}
        </section>
      </div>

      {/* user public profile header */}
      {authState?.loggedUser?.slug && (
        <div className="py-2 px-3 bg-[transparent] border border-solid border-[#6E0651] rounded-lg flex flex-col items-start justify-center gap-1">
          <span className="font-semibold text-sm leading-5 tracking-[0%] text-center bg-clip-text text-transparent bg-gradient-to-r from-[#B44D9A] to-[#B44D9A]">
            Media Kit Link
          </span>
          <div
            className="w-full flex items-center justify-between text-[#9C9C9C] hover:text-[#fff] text-xs cursor-pointer"
            onClick={() => {
              mixpanel.track("Clicked on Public Profile link in Sidebar");
              authState?.loggedUser?.activePlan
                ? window.open(
                    `${window.location.protocol}//${window.location.host}/${authState?.loggedUser?.slug}`
                  )
                : navigate("/influencer/payment");
            }}
          >
            {window.location.host}/
            {authState?.loggedUser?.slug?.slice(0, 10) + "..."}
            <MdOutlineContentCopy
              className="cursor-pointer text-[#6E0651] h-4 w-4 "
              onClick={(e) => {
                e.stopPropagation();
                mixpanel.track("Coppied Public Profile link from Sidebar");
                navigator.clipboard.writeText(
                  `${window.location.protocol}//${window.location.host}/${authState?.loggedUser?.slug}?utm_source=collab_dashboard`
                );

                toast.info("Link Copied", {
                  position: "top-center",
                  autoClose: 1000,
                });
              }}
            />
          </div>
        </div>
      )}

      {authState?.loggedUser?.referralCode && (
        <div className="py-2 px-3 bg-[transparent] border border-solid border-[#6E0651] rounded-lg flex flex-col items-start justify-center gap-1">
          <span className="font-semibold text-sm leading-5 tracking-[0%] text-center bg-clip-text text-transparent bg-gradient-to-r from-[#B44D9A] to-[#B44D9A]">
            Referral Link
          </span>
          <div
            className="w-full flex items-center justify-between text-[#9C9C9C] hover:text-[#fff] text-xs cursor-pointer"
            onClick={() => {
              mixpanel.track("Clicked on Public Profile link in Sidebar");
              window.open(
                `${window.location.protocol}//${window.location.host}/influencer/?refer=${authState?.loggedUser?.referralCode}`
              );
            }}
          >
            {window.location.host}
            {`/influencer/?refer=${authState?.loggedUser?.referralCode}`?.slice(
              0,
              10
            ) + "..."}
            <MdOutlineContentCopy
              className="cursor-pointer text-[#6E0651] h-4 w-4 "
              onClick={(e) => {
                e.stopPropagation();
                mixpanel.track("Coppied Public Profile link from Sidebar");
                navigator.clipboard.writeText(
                  `${window.location.protocol}//${window.location.host}/influencer/?refer=${authState?.loggedUser?.referralCode}`
                );

                toast.info("Link Copied", {
                  position: "top-center",
                  autoClose: 1000,
                });
              }}
            />
          </div>
        </div>
      )}

      {/* tags ------------ */}

      <section className="flex flex-col items-start gap-4">
        {/* Dahsboard */}
        <span
          className={`text-sm font-medium ${
            location.pathname === "/influencer/dashboard" ||
            location.pathname === "/influencer"
              ? "text-[#FFFFFF] bg-[#381c1c]"
              : "text-[#A6A6A6] bg-transparent"
          }  w-full py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2`}
          onClick={() => {
            mixpanel.track("Clicked on Dashboard link in Sidebar");
            navigate("/influencer/dashboard");
          }}
        >
          <PiSquaresFourLight size={18} /> Dashboard
        </span>

        {/* Boost Visibility */}
        {authState?.loggedUser?.slug && (
          <span
            className={`text-sm font-medium md:flex hidden ${
              location.pathname === "/influencer/boostVisibility"
                ? "text-[#FFFFFF] bg-[#381c1c]"
                : "text-[#A6A6A6] bg-transparent"
            }  w-full py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2 justify-between`}
            onClick={() => {
              mixpanel.track("Clicked on Boost Visibility link in Sidebar");
              navigate("/influencer/boostVisibility");
            }}
          >
            <div className="flex gap-2">
              <IoFlashOutline size={18} /> Boost Visibility
            </div>
            <span className="bg-red-700 text-white rounded-full text-[10px] px-2">
              New
            </span>
          </span>
        )}

        {/* Posts Performance */}
        <span
          className={`text-sm font-medium ${
            location.pathname === "/influencer/posts-performance" ||
            location.pathname === "/influencer"
              ? "text-[#FFFFFF] bg-[#381c1c]"
              : "text-[#A6A6A6] bg-transparent"
          }  w-full py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2 justify-between`}
          onClick={() => {
            mixpanel.track("Clicked on feed link in Sidebar");
            navigate("/influencer/posts-performance");
          }}
        >
          <div className="flex gap-2">
            <MdAutoGraph size={18} />
            <span>Post Performance</span>
          </div>
          {/* <span className="bg-red-700 text-white rounded-full text-[10px] px-2">
            New
          </span> */}
        </span>

        {/* Earning */}
        <span
          className={`text-sm font-medium ${
            location.pathname === "/influencer/wallet" ||
            location.pathname === "/influencer"
              ? "text-[#FFFFFF] bg-[#381c1c]"
              : "text-[#A6A6A6] bg-transparent"
          }  w-full py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2 justify-between`}
          onClick={() => {
            mixpanel.track("Clicked on Earning link in Sidebar");
            navigate("/influencer/wallet");
          }}
        >
          <div className="flex gap-2">
            <Wallet size={18} />
            <span>Earning</span>
          </div>
          <span className="bg-red-700 text-white rounded-full text-[10px] px-2">
            New
          </span>
        </span>

        {/* Feed */}
        <span
          className={`text-sm font-medium ${
            location.pathname === "/influencer/feed" ||
            location.pathname === "/influencer"
              ? "text-[#FFFFFF] bg-[#381c1c]"
              : "text-[#A6A6A6] bg-transparent"
          }  w-full py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2 justify-between`}
          onClick={() => {
            mixpanel.track("Clicked on feed link in Sidebar");
            navigate("/influencer/feed");
          }}
        >
          <div className="flex gap-2">
            <CgFeed size={18} />
            <span>Feed</span>
          </div>
          {/* <span className="bg-red-700 text-white rounded-full text-[10px] px-2">
            New
          </span> */}
        </span>

        {/* network */}
        {/* <span
          className={`text-sm font-medium ${
            location.pathname === "/influencer/network" ||
            location.pathname === "/influencer"
              ? "text-[#FFFFFF] bg-[#381c1c]"
              : "text-[#A6A6A6] bg-transparent"
          }  w-full py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2`}
          onClick={() => {
            mixpanel.track("Clicked on network link in Sidebar");
            navigate("/influencer/network");
          }}
        >
          <BiNetworkChart size={18} /> My Network
        </span> */}

        {/* Analytics */}
        {/* <span
          className={`text-sm font-medium ${
            location.pathname === "/influencer/analytics"
              ? "text-[#FFFFFF] bg-[#381c1c]"
              : "text-[#A6A6A6] bg-transparent"
          }  w-full py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FAFAFA] rounded-md cursor-pointer flex justify-between items-center gap-2`}
          onClick={() => {
            mixpanel.track("Clicked on Analytics link in Sidebar");
            navigate("/influencer/analytics");
          }}
        >
          <span className="gap-2 flex">
            <TbDeviceAnalytics size={18} /> Analytics
          </span>
        </span> */}

        {/* Boost Visibility */}
        {/* {authState?.loggedUser?.slug && (
          <span
            className={`text-sm font-medium ${
              location.pathname === "/influencer/boostVisibility"
                ? "text-[#FFFFFF] bg-[#381c1c]"
                : "text-[#A6A6A6] bg-transparent"
            }  w-full py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2`}
            onClick={() => {
              mixpanel.track("Clicked on Boost Visibility link in Sidebar");
              navigate("/influencer/boostVisibility");
            }}
          >
            <IoFlashOutline size={18} /> Boost Visibility
          </span>
        )} */}

        {/* Platform Integration */}
        {/* {authState?.loggedUser?.slug && (
          <span
            className={`text-sm font-medium ${
              location.pathname === "/influencer/apps"
                ? "text-[#FFFFFF] bg-[#381c1c]"
                : "text-[#A6A6A6] bg-transparent"
            }  w-full py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2`}
            onClick={() => {
              mixpanel.track("Clicked on Platform Integration link in Sidebar");
              navigate("/influencer/apps");
            }}
          >
            <Unplug size={18} /> Platform Integration
          </span>
        )} */}

        {/* Brand Deals */}
        <span
          className={`text-sm font-medium ${
            location.pathname === "/influencer/brandCollabs"
              ? "text-[#FFFFFF] bg-[#381c1c]"
              : "text-[#A6A6A6] bg-transparent"
          }  w-full py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FAFAFA] rounded-md cursor-pointer flex justify-between items-center gap-2`}
          onClick={() => {
            mixpanel.track("Clicked on Brand Deals link in Sidebar");
            navigate("/influencer/brandCollabs");
          }}
        >
          <span className="gap-2 flex">
            <IoDiamondOutline size={18} /> Brand Deals
          </span>
          <span
            style={{
              background:
                "linear-gradient(rgba(243, 108, 108, 1), rgba(254, 191, 255, 1))",
            }}
            className="w-[15px] h-[15px] rounded-full flex items-center justify-center"
          >
            <span className="animate-pulse inline-flex w-[10px] h-[10px] bg-[#FFFFFF] rounded-full opacity-75"></span>
          </span>
        </span>

        {/* Brand Collabs */}
        {/* <span
          className={`text-sm font-medium ${
            location.pathname === "/influencer/brandCollabs"
              ? "text-[#FFFFFF] bg-[#381c1c]"
              : "text-[#A6A6A6] bg-transparent"
          }  w-full py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FAFAFA] rounded-md cursor-pointer flex justify-between items-center gap-2`}
          onClick={() => {
            mixpanel.track("Clicked on Brand Collabs link in Sidebar");
            navigate("/influencer/brandCollabs");
          }}
        >
          <span className="gap-2 flex">
            <IoDiamondOutline size={18} /> Brand Collabs
          </span>
          <span
            style={{
              background:
                "linear-gradient(rgba(243, 108, 108, 1), rgba(254, 191, 255, 1))",
            }}
            className="w-[15px] h-[15px] rounded-full flex items-center justify-center"
          >
            <span className="animate-pulse inline-flex w-[10px] h-[10px] bg-[#FFFFFF] rounded-full opacity-75"></span>
          </span>
        </span> */}

        {/* tools */}
        {/* <span
          className={`text-sm font-medium ${
            location.pathname === "/influencer/tools" ||
            location.pathname === "/influencer/tools"
              ? "text-[#FFFFFF] bg-[#381c1c]"
              : "text-[#A6A6A6] bg-transparent"
          } w-full py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FFFFFF] rounded-md cursor-pointer flex items-center gap-2`}
          onClick={() => {
            mixpanel.track("Clicked on Brand Wishlist link in Sidebar");
            navigate("/influencer/tools");
          }}
        >
          <Wrench size={18} /> Free Tools
        </span> */}

        {/* Profile building */}
        <Accordion className="w-full" type="single" collapsible>
          <AccordionItem value="item-1">
            <AccordionTrigger
              className={`text-sm font-medium ${
                location.search === "" &&
                location.pathname === "/influencer/build_profile"
                  ? "text-[#FFFFFF] bg-[#381c1c]"
                  : "text-[#A6A6A6] bg-transparent"
              } w-full py-[6px] relative px-3 hover:bg-[#381c1c] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2`}
            >
              <div className="flex gap-[8px]">
                <CgProfile size={18} /> Build Media Kit
              </div>
            </AccordionTrigger>
            <AccordionContent>
              <section className="flex flex-col items-center gap-4 text-sm w-full px-3 box-border mb-3 mt-1">
                {/* personal information */}
                <span
                  className={`cursor-pointer ${
                    location.search === "?page=profile" &&
                    location.pathname === "/influencer/build_profile"
                      ? "text-[#FFFFFF] bg-[#381c1c]"
                      : "text-[#A6A6A6] bg-transparent"
                  } hover:text-[#FFFFFF] flex items-center justify-between w-full px-[8px] py-[6px] rounded-sm `}
                  onClick={() => {
                    mixpanel.track(
                      "Clicked on Personal Information link in Sidebar"
                    );
                    navigate("/influencer/build_profile?page=profile");
                  }}
                >
                  Personal Information
                  {window.location.pathname === "/influencer/build_profile" && (
                    <span className="flex text-xs items-center gap-2">
                      <GiTwoCoins color="#FFD700" />{" "}
                      {generalState.SidebarChipsCount.profile || 0}
                    </span>
                  )}
                </span>
                {/* content expertise */}
                {!authState?.loggedUser?.extensionUsage?.lastSyncTime && (
                  <span
                    className={`cursor-pointer ${
                      location.search === "?page=content" &&
                      location.pathname === "/influencer/build_profile"
                        ? "text-[#FFFFFF] bg-[#381c1c]"
                        : "text-[#A6A6A6] bg-transparent"
                    } hover:text-[#FFFFFF] flex items-center justify-between w-full px-[8px] py-[6px] rounded-sm  `}
                    onClick={() => {
                      mixpanel.track(
                        "Clicked on Content Expertise link in Sidebar"
                      );
                      navigate("/influencer/build_profile?page=content");
                    }}
                  >
                    Content Expertise
                    {window.location.pathname ===
                      "/influencer/build_profile" && (
                      <span className="flex text-xs items-center gap-2">
                        <GiTwoCoins color="#FFD700" />{" "}
                        {generalState.SidebarChipsCount.content || 0}
                      </span>
                    )}
                  </span>
                )}
                {/* Audience Info */}
                {
                  <span
                    className={`cursor-pointer ${
                      location.search === "?page=audience" &&
                      location.pathname === "/influencer/build_profile"
                        ? "text-[#FFFFFF] bg-[#381c1c]"
                        : "text-[#A6A6A6] bg-transparent"
                    } hover:text-[#FFFFFF] flex items-center justify-between w-full px-[8px] py-[6px] rounded-sm  `}
                    onClick={() => {
                      mixpanel.track(
                        "Clicked on Audience Info link in Sidebar"
                      );
                      navigate("/influencer/build_profile?page=audience");
                    }}
                  >
                    Audience info
                    {window.location.pathname ===
                      "/influencer/build_profile" && (
                      <span className="flex text-xs items-center gap-2">
                        <GiTwoCoins color="#FFD700" />{" "}
                        {generalState.SidebarChipsCount.audience || 0}
                      </span>
                    )}
                  </span>
                }
                {/* collab portfolio */}
                <span
                  className={`cursor-pointer ${
                    location.search === "?page=collab" &&
                    location.pathname === "/influencer/build_profile"
                      ? "text-[#FFFFFF] bg-[#381c1c]"
                      : "text-[#A6A6A6] bg-transparent"
                  } hover:text-[#FFFFFF] flex items-center justify-between w-full px-[8px] py-[6px] rounded-sm  `}
                  onClick={() => {
                    mixpanel.track(
                      "Clicked on Collab Portfolio link in Sidebar"
                    );
                    navigate("/influencer/build_profile?page=collab");
                  }}
                >
                  Collab Portfolio
                  {window.location.pathname === "/influencer/build_profile" && (
                    <span className="flex text-xs items-center gap-2">
                      <GiTwoCoins color="#FFD700" />{" "}
                      {generalState.SidebarChipsCount.collab || 0}
                    </span>
                  )}
                </span>
                {/* monetization expertize */}
                <span
                  className={`cursor-pointer ${
                    location.search === "?page=monetization" &&
                    location.pathname === "/influencer/build_profile"
                      ? "text-[#FFFFFF] bg-[#381c1c]"
                      : "text-[#A6A6A6] bg-transparent"
                  } hover:text-[#FFFFFF] flex items-center justify-between w-full px-[8px] py-[6px] rounded-sm  `}
                  onClick={() => {
                    mixpanel.track(
                      "Clicked on Monetization Expertise link in Sidebar"
                    );
                    navigate("/influencer/build_profile?page=monetization");
                  }}
                >
                  Monetization Expertise
                  {window.location.pathname === "/influencer/build_profile" && (
                    <span className="flex text-xs items-center gap-2">
                      <GiTwoCoins color="#FFD700" />{" "}
                      {generalState.SidebarChipsCount.monetization || 0}
                    </span>
                  )}
                </span>
                {/* control your pricing */}
                <span
                  className={`cursor-pointer ${
                    location.search === "?page=pricing" &&
                    location.pathname === "/influencer/build_profile"
                      ? "text-[#FFFFFF] bg-[#381c1c]"
                      : "text-[#A6A6A6] bg-transparent"
                  } hover:text-[#FFFFFF] flex items-center justify-between w-full px-[8px] py-[6px] rounded-sm  `}
                  onClick={() => {
                    mixpanel.track(
                      "Clicked on Control Your Pricing link in Sidebar"
                    );
                    navigate("/influencer/build_profile?page=pricing");
                  }}
                >
                  Control Your Pricing
                  {window.location.pathname === "/influencer/build_profile" && (
                    <span className="flex text-xs items-center gap-2">
                      <GiTwoCoins color="#FFD700" />{" "}
                      {generalState.SidebarChipsCount.charges || 0}
                    </span>
                  )}
                </span>
                {/* make it visible */}
                {!authState?.loggedUser?.activePlan && (
                  <span
                    className={`cursor-pointer ${
                      location.pathname === "/influencer/payment"
                        ? "text-[#FFFFFF] bg-[#381c1c]"
                        : "text-[#A6A6A6] bg-transparent"
                    } hover:text-[#FFFFFF] flex items-center justify-between w-full px-[8px] py-[6px] rounded-sm  `}
                    onClick={() => {
                      mixpanel.track(
                        "Clicked on Make Me Visible link in Sidebar"
                      );
                      navigate("/influencer/payment");
                    }}
                  >
                    Make Me Visible
                  </span>
                )}
              </section>
            </AccordionContent>
          </AccordionItem>
        </Accordion>

        {/* brand wishlist */}
        {/* <span
          className={`text-sm font-medium ${
            location.pathname === "/influencer/brands_wishlist" ||
            location.pathname === "/influencer/view_brands_list"
              ? "text-[#FFFFFF] bg-[#381c1c]"
              : "text-[#A6A6A6] bg-transparent"
          } w-full py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FFFFFF] rounded-md cursor-pointer flex items-center gap-2`}
          onClick={() => {
            mixpanel.track("Clicked on Brand Wishlist link in Sidebar");
            navigate("/influencer/brands_wishlist");
          }}
        >
          <MdLoyalty size={18} /> Brand Wishlist
        </span> */}

        {/* guid hub */}
        <Accordion className=" w-full " type="single" collapsible>
          <AccordionItem value="item-1">
            {/* <AccordionTrigger
              className={`text-sm font-medium text-[#A6A6A6] bg-[transparent]
          } w-full py-[6px] relative px-3 hover:text-[#FFFFFF] rounded-md cursor-pointer flex items-center gap-2`}
            >
              <div className="flex gap-[8px] ">
                <MdAutoStories size={18} /> Guide Hub
              </div>
            </AccordionTrigger> */}
            <AccordionContent>
              <section className="flex flex-col items-center gap-4 text-sm w-full px-3 box-border mb-3 ">
                {/* profile guide */}
                <span
                  className={`text-[#A6A6A6] cursor-pointer hover:text-[#FFFFFF] flex items-center justify-between w-full px-[8px] py-[6px] rounded-sm `}
                  onClick={() => {
                    mixpanel.track(
                      "Clicked on Your Profile Guide link in Sidebar"
                    );
                    window.open("https://bit.ly/anchorscollabguide", "_blank");
                  }}
                >
                  Your Profile Guide <IoMdOpen />
                </span>
                {/* faq */}
                <span
                  className={`text-[#A6A6A6] cursor-pointer hover:text-[#FFFFFF] flex items-center justify-between w-full px-[8px] py-[6px] rounded-sm `}
                  onClick={() => {
                    mixpanel.track("Clicked on FAQ link in Sidebar");
                    window.open("https://bit.ly/collabchips", "_blank");
                  }}
                >
                  Chips: FAQs Answered <IoMdOpen />
                </span>
              </section>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </section>
    </div>
  );
};

export default Sidebar;
